module.exports = __webpack_public_path__ + "static/media/logo-white.dea2c12e.svg";